import React, { useCallback, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import defaultImage from "../../images/defaultImage.png";
import { CommonUtil } from "../../utils/CommonUtil";
import FacebookIcon from "@mui/icons-material/Facebook";
import { NetworkManager } from "../../Components/NetworkManager";

interface FacebookManageProps {}

const FacebookManage: React.FC<FacebookManageProps> = () => {
  const history = useNavigate();
  const location = useLocation();
  const [pagesData, setPagesData] = useState<any[]>();
  const [pagesCount, setPagesCount] = useState<number>(0);
  const [selectedTab, setSelectedTab] = useState<string>("nav-fb-tab");
  const [, setFbPagesData] = useState<any>({});
  const [fbAccessToken] = useState<any>("");
  const [systemId] = useState<any>("");

  const ontabChange = (e: any) => {
    console.log(e.target.id);

    setSelectedTab(e.target.id);
  };

  const onSuccessCall = useCallback(
    (data: any) => {
      var respData = CommonUtil.parseData(data);
      if (respData && !respData.error) {
        history("/connectSuccess");
      } else {
        history("/connectError");
      }
    },
    [history]
  );
  const onSuccessCallBroadcast = useCallback(
    (data: any) => {
      var respData = CommonUtil.parseData(data);
      if (respData && !respData.error) {
        history("/connectSuccess");
      } else {
        history("/connectError");
      }
    },
    [history]
  );

  const onErrorCall = useCallback((err: any) => {}, []);

  useEffect(() => {
    const { authCode, authType } = location.state ?? {};
    if (!authCode) return;

    const endpoint =
      authType === "connect"
        ? "api/account/save"
        : "broadcast/connect/fbUserAccount/save";

    const onSuccess =
      authType === "connect" ? onSuccessCall : onSuccessCallBroadcast;

    const body: Record<string, string> = { code: authCode };
    if (authType === "partner") body.flowType = "FLOW_3";

    NetworkManager.sendJsonRequest(
      endpoint,
      body,
      "",
      "POST",
      true,
      onSuccess,
      onErrorCall,
    );
  }, [
    location.state.authCode,
    location.state.authType,
    onSuccessCall,
    onSuccessCallBroadcast,
    onErrorCall,
  ]);

  const fetchBCastPages = () => {
    let pageData = {
      systemUserId: systemId,
    };
    NetworkManager.sendJsonRequest(
      "broadcast/connect/fbUserAccount/getPages",
      pageData,
      "",
      "POST",
      true,
      onBCastPageSuccessCall,
      onPageErrorCall,
    );
  };
  const fetchAdAccuntPages = () => {
    let pageData = {
      systemUserId: systemId,
    };
    NetworkManager.sendJsonRequest(
      "broadcast/connect/fbUserAccount/getAdAccounts",
      pageData,
      "",
      "POST",
      true,
      onAdAccuntPageSuccessCall,
      onPageErrorCall,
    );
  };
  const fetchPages = () => {
    const pageData = {
      accessToken: fbAccessToken,
    };
    NetworkManager.sendJsonRequest(
      "api/account/pages",
      pageData,
      "",
      "POST",
      true,
      onPageSuccessCall,
      onPageErrorCall,
    );
  };

  const onPageSuccessCall = (data: any) => {
    var respData = CommonUtil.parseData(data);
    if (respData.statusCode === "P0002") {
      let tempArray: any = [];
      setPagesData(tempArray);
      saveFbPagesData(respData);
    } else {
      saveFbPagesData(respData);
      setPagesData(respData.pages);
      setPagesCount(respData.pages && respData.pages.length);
    }
  };
  const onBCastPageSuccessCall = (data: any) => {
    var respData = CommonUtil.parseData(data);
    if (respData.statusCode === "BM0000") {
      saveFbPagesData(respData);
      setPagesData(respData.fbPageDetails);
      setPagesCount(respData.fbPageDetails && respData.fbPageDetails.length);
      // fetchAdAccuntPages();
    }
  };
  const onAdAccuntPageSuccessCall = (_data: any) => {};

  const onPageErrorCall = (err: any) => {};

  const handleConnect = (id: any, pageId: any, isConnected: boolean) => {
    if (isConnected) {
      return;
    }
    if (id) {
      let connectData = {
        fbPageId: pageId,
        accessToken: fbAccessToken,
      };
      NetworkManager.sendJsonRequest(
        "api/account/page/connect",
        connectData,
        "",
        "POST",
        true,
        onConnectSuccessCall,
        onConnectErrorCall,
      );
    } else if (pageId) {
      let connectData = {
        pageId: pageId,
        systemUserId: systemId,
      };
      NetworkManager.sendJsonRequest(
        "broadcast/connect/fbUserAccount/page/connect",
        connectData,
        "",
        "POST",
        true,
        onConnectBCastSuccessCall,
        onConnectErrorCall,
      );
    }
  };

  const onConnectSuccessCall = (data: any) => {
    var respData = CommonUtil.parseData(data);
    if (respData.error) {
      history("/connectError");
    } else if (respData) {
      history("/facebookManage");
      fetchPages();
    }
  };
  const onConnectBCastSuccessCall = (data: any) => {
    var respData = CommonUtil.parseData(data);
    if (respData.error) {
      history("/connectError");
    } else if (respData) {
      history("/facebookManage");
      fetchBCastPages();
      fetchAdAccuntPages();
    }
  };

  const onConnectErrorCall = (err: any) => {
    history("/connectError");
  };

  const saveFbPagesData = (data: any) => {
    setFbPagesData(data);
  };

  return (
    <>
      <div className="account-pages container-login100 mt-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12 text-center mb-2">
              <img src="../assets/images/Logo.png" alt="" />
            </div>
          </div>{" "}
          <div className="row justify-content-center mb-4 manage">
            <div className="col-md-12 col-lg-8 col-xl-6">
              <div className="manage-page">
                <nav>
                  <div
                    className="nav nav-tabs justify-content-center"
                    id="nav-tab"
                    role="tablist">
                    <button
                      className={`nav-item nav-link ${
                        selectedTab === "nav-fb-tab" ? "active" : ""
                      }`}
                      id="nav-fb-tab"
                      data-toggle="tab"
                      role="tab"
                      aria-controls="nav-home"
                      aria-selected="true"
                      onClick={ontabChange}>
                      {" "}
                      <FacebookIcon color="primary" />
                      Facebook
                    </button>
                    {/* <button
                      className={`nav-item nav-link ${
                        selectedTab === "nav-inst-tab" ? "active" : ""
                      }`}
                      style={{ display: "none" }}
                      id="nav-inst-tab"
                      data-toggle="tab"
                      role="tab"
                      aria-controls="nav-profile"
                      aria-selected="false"
                      onClick={ontabChange}>
                      <InstagramIcon color="secondary" />
                      Instagram
                    </button> */}
                  </div>
                </nav>{" "}
                <>
                    <div className="text-center">
                      <h3 className="fbtext">
                        {pagesData ? (
                          <div>
                            We found {pagesCount ? pagesCount : 0} Facebook
                            Pages managed by you.
                          </div>
                        ) : (
                          <div>Fetching Facebook Pages</div>
                        )}
                      </h3>
                    </div>
                    {pagesData && pagesCount > 0
                      ? pagesData.map((item, index) => {
                          const pagestatus = item?.pageStatus === "CONNECTED";
                          const pageConnectionStatus =
                            item?.pageConnectionStatus === "CONNECTED";
                          return (
                            <div className="card" key={index}>
                              <div className="card-body">
                                <div className="d-flex justify-content-between align-items-center">
                                  <div className="widgets_div d-flex align-items-center">
                                    <div className="icon_div">
                                      <span>
                                        {item.picture || item.pagePictureUrl ? (
                                          <img
                                            src={
                                              item.picture ||
                                              item.pagePictureUrl
                                            }
                                            className="rounded-circle avatar-sm"
                                            alt=""
                                          />
                                        ) : (
                                          <img
                                            src={defaultImage}
                                            alt=""
                                            style={{
                                              width: "50px",
                                              height: "50px",
                                              borderRadius: "50%",
                                            }}
                                          />
                                        )}
                                      </span>
                                    </div>{" "}
                                    <div className="av-div">
                                      {item.pageName}
                                    </div>
                                  </div>{" "}
                                  <div className="text-right">
                                    <button
                                      type="button"
                                      className={`btn rounded-pill btn-small btn-sm ${
                                        pagestatus || pageConnectionStatus
                                          ? "btn-secondary"
                                          : "btn-primary"
                                      }`}
                                      onClick={() =>
                                        handleConnect(
                                          item.pageAccessToken,
                                          item.pageId,
                                          pagestatus || pageConnectionStatus,
                                        )
                                      }>
                                      {pagestatus || pageConnectionStatus
                                        ? "Connected"
                                        : "Connect"}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      : null}
                  </>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FacebookManage;
